import './style.scss';
import infoCircleBlue from '../../../../assets/icons/info-circle-filled-blue-800.svg';
import exclamationTriangleOrange from '../../../../assets/icons/exclamation-triangle-filled-orange-500.svg';
import exclamationHexagonRed from '../../../../assets/icons/exclamation-hexagon-filled-red-600.svg';
import { Severity } from '../../../models/note.model';
import DataUrlHelper from '../../../helpers/data-url.helper';
import { t } from '../../../services/texts.service';

function getIconUrl(severity: Severity | undefined): string {
  if (severity === Severity.high) {
    return DataUrlHelper.encode(exclamationHexagonRed);
  }
  if (severity === Severity.normal) {
    return DataUrlHelper.encode(exclamationTriangleOrange);
  }
  if (severity === Severity.low) {
    return DataUrlHelper.encode(infoCircleBlue);
  }
  return '';
}

function getIconAltText(severity: Severity | undefined): string {
  if (severity === Severity.high) {
    return t('Stor påverkan', 'Severe impact');
  }
  if (severity === Severity.normal) {
    return t('Medelstor påverkan', 'Moderate impact');
  }
  if (severity === Severity.low) {
    return t('Liten påverkan', 'Slight impact');
  }
  return '';
}

function SeverityIcon({ severity, className }: { severity: Severity | undefined; className?: string }) {
  return <img src={getIconUrl(severity)} alt={getIconAltText(severity)} className={`severity-icon ${className ?? ''}`}></img>;
}

export default SeverityIcon;
